// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"228":"252f366e","230":"component---src-pages-index-jsx","445":"1bfc9850","778":"c7773329"}[chunkId] + "-" + {"228":"3c993af394b21f57f94a","230":"ccfee76329ae93ca06bf","445":"f69199d74579626d9057","778":"a99334be75bdf7c300d7"}[chunkId] + ".js";
};